import { render } from "./alertModal.vue?vue&type=template&id=5889e6b4&ts=true"
import script from "./alertModal.vue?vue&type=script&lang=ts"
export * from "./alertModal.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\fpbillions\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__